import React from 'react';
import { Badge, Typography } from 'antd';
import PropTypes from 'prop-types';

import { AimOutlined, QuestionCircleOutlined } from '@ant-design/icons';

const { Text } = Typography;

const SET_TYPE_OPTIONS = [
    {
        key: 'strategy',
        label: 'Strategy Sets',
        icon: <AimOutlined />,
        description: 'Sets following trading strategy'
    },
    {
        key: 'noStrategy',
        label: 'No Strategy Sets',
        icon: <QuestionCircleOutlined />,
        description: 'Sets without specific strategy'
    }
];

export default function SetTypeSidePanel({ selectedSetType, onSelectSetType, setCounts }) {
    return (
        <div className="set-type-side-panel">
            <div className="panel-header">
                <Text strong>Set Categories</Text>
            </div>
            <div className="panel-options">
                {SET_TYPE_OPTIONS.map((option) => (
                    <div
                        key={option.key}
                        className={`set-type-option ${
                            selectedSetType === option.key ? 'selected' : ''
                        }`}
                        onClick={() => onSelectSetType(option.key)}
                        role="button"
                        tabIndex={0}
                        onKeyPress={(e) => e.key === 'Enter' && onSelectSetType(option.key)}
                    >
                        <div className="option-icon">{option.icon}</div>
                        <div className="option-content">
                            <div className="option-label">
                                <Text strong>{option.label}</Text>
                                <Badge
                                    count={setCounts[option.key]}
                                    showZero
                                    style={{
                                        backgroundColor:
                                            selectedSetType === option.key ? '#1890ff' : '#d9d9d9',
                                        marginLeft: 8
                                    }}
                                />
                            </div>
                            <Text type="secondary" className="option-description">
                                {option.description}
                            </Text>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}

SetTypeSidePanel.propTypes = {
    selectedSetType: PropTypes.string.isRequired,
    onSelectSetType: PropTypes.func.isRequired,
    setCounts: PropTypes.shape({
        strategy: PropTypes.number,
        noStrategy: PropTypes.number
    }).isRequired
};
